import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSizes } from 'src/app/Services/enum';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class PaginationComponent {
  @Input() currentPage = 1;
  @Input() totalRecords = 1;
  @Input() totalPages = 1;
  @Input() pageSizes: number[] = PageSizes;
  @Input() itemsPerPage = PageSizes[0];
  @Input() pagesToShow: (number | -1)[] = [];

  @Output() pageChange = new EventEmitter<number>();
  @Output() itemsPerPageChange = new EventEmitter<number>();

  isDropdownOpen = false;

  get startRecord(): number {
    return this.totalRecords>0?(this.currentPage - 1) * this.itemsPerPage + 1:0;
  }

  get endRecord(): number {
    const end = this.currentPage * this.itemsPerPage;
    return end > this.totalRecords ? this.totalRecords : end;
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }

  setItemsPerPage(size: number) {
    this.itemsPerPageChange.emit(size);
    this.isDropdownOpen = false;
  }
}
